import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
	align-items: center;
	margin-top: 80px;

	@media (max-width: 992px) {
		flex-direction: column-reverse;
	}
`;

export const Right = styled.div`
	display: flex;
	flex-direction: column;
	width: 50%;
	font-size: 56px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		width: 100%;
		align-items: center;
		text-align: center;
	}
`;

export const Description = styled.div`
	font-size: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin-top: 16px;

	@media (max-width: 992px) {
		font-size: 18px;
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	margin-top: 16px;
`;

export const Title = styled.div`
	font-size: 56px;
	font-weight: 700;

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 992px) {
		font-size: 36px;
	}
`;

export const Left = styled.div`
	display: flex;
	width: 50%;
	margin-top: 30px;
	margin-bottom: 30px;
	height: 600px;

	img {
		max-width: 600px;
		width: 100%;
		object-fit: contain;
	}

	@media (max-width: 992px) {
		justify-content: center;
		width: 100%;
		height: auto;
	}
`;
